var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"background",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"custom-sidebar",attrs:{"cols":"auto"}},[_c('sidebar')],1),_c('v-col',{staticClass:"custom-container"},[_c('toolbar'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }